<template>
  <form @submit.prevent="handleCreateAssessment">
            <h3>Cerate new Assessment</h3>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-stacked-text">Title</label>
                <div class="uk-form-controls">
                    <input
                    :class="{
                        'uk-input': true,
                        'uk-form-danger': errors.has('title')
                    }"
                    type="text"
                    name="title"
                    v-validate="'required'"
                    v-model="assessment.title">
                    <div v-if="submitted && errors.has('title')" class="uk-text-danger">{{errors.first('title')}}</div>
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-stacked-description">Description</label>
                <div class="uk-form-controls">
                    <textarea
                    :class="{
                        'uk-textarea': true,
                        'uk-form-danger': errors.has('description')
                    }"
                    rows="5"
                    name="description"
                    v-validate="'required'"
                    v-model="assessment.description"
                    ></textarea>
                    <div v-if="submitted && errors.has('description')" class="uk-text-danger">{{errors.first('description')}}</div>
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-stacked-select">Type</label>
                <div class="uk-form-controls">
                    <select
                    :class="{
                            'uk-select': true,
                            'uk-form-danger': errors.has('type')
                    }"
                    name="type"
                    v-validate="'required'"    
                    v-model="assessment.type"
                    >
                        <option value="Radar">Radar</option>
                        <option value="Energy">Energy</option>
                    </select>
                    <div v-if="submitted && errors.has('type')" class="uk-text-danger">{{errors.first('type')}}</div>
                </div>
            </div>
            <div class="uk-margin">
                <div class="uk-form-label">Display the questions in a random order or as they are set?</div>
                <div class="uk-form-controls">
                    <label><input :class="{'uk-radio': true, 'uk-form-danger': errors.has('random')}" v-validate="'required'" type="radio" name="random" :value="true" v-model="assessment.isRandom" :checked="assessment.isRandom"> Yes </label>&nbsp;&nbsp;
                    <label><input :class="{'uk-radio': true, 'uk-form-danger': errors.has('random')}" v-validate="'required'" type="radio" name="random" :value="false" v-model="assessment.isRandom" :checked="assessment.isRandom"> No </label>
                    <div v-if="submitted && errors.has('random')" class="uk-text-danger">{{errors.first('random')}}</div>
                </div>
            </div>
            <div class="uk-margin uk-text-center">
                <button class="uk-button uk-button-primary uk-width-1-4" :disabled="successful">Create</button>
            </div>
            <p v-if="message" class="uk-text-center uk-text-small" :class="successful ? 'uk-text-success' : 'uk-text-danger'">{{message}}</p>
      </form>
</template>

<script>
import Assessment from '@/models/assessment';
import AssessmentService from '@/services/assessment.service';
export default {
    name: 'Create',
    data() {
        return {
            assessment: new Assessment('', '', '', ''),
            message: '',
            successful: false,
            submitted: false
        }
    },
    methods: {
        handleCreateAssessment() {
            this.message = '';
            this.submitted = true;
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    AssessmentService.create(this.assessment).then(
                        res => {
                            this.message = res.data.message;
                            this.successful = true;
                            setTimeout(() =>  this.$router.push({ name: 'assessment.update', params: { id: res.data.id } }), 3000);
                        },
                        error => {
                            this.message = 
                            (error.response && error.response.data.message) ||
                            error.message || error.toString();
                            this.successful = false;
                        }
                    );
                }
            });
        }
    }
}
</script>

<style>

</style>